import { Component, OnInit, Self, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { StateService } from '@uirouter/angular';

import { of, throwError } from 'rxjs';
import { catchError, switchMap, takeUntil } from 'rxjs/operators';
import { RecaptchaComponent } from 'ng-recaptcha';

import { BackgroundBrandedService } from '@app/shared/modules/background-branded/services/background-branded.service';
import { fbEmailValidator } from '@app/modules/ui/validators/email-validator';
import { NgOnDestroy } from '@app/shared/services/ng-on-destroy.service';
import { UserResource } from '@app/shared/modules/resources/user.resource';
import { RecaptchaService } from '@app/shared/modules/recaptcha/recaptcha.service';

@Component({
  providers: [NgOnDestroy],
  selector: 'app-find-company',
  templateUrl: './find-company.component.html',
  standalone: false
})
export class FindCompanyComponent implements OnInit {
  isLoaded = false;
  isInProgress = false;

  findCompanyForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, fbEmailValidator()])
  });

  @ViewChild(RecaptchaComponent) recaptcha: RecaptchaComponent;

  constructor(
    @Self() private destroy: NgOnDestroy,
    private backgroundBrandedService: BackgroundBrandedService,
    private stateService: StateService,
    private userResource: UserResource,
    public recaptchaService: RecaptchaService
  ) {}

  get emailControl() {
    return this.findCompanyForm.controls.email;
  }

  ngOnInit(): void {
    this.backgroundBrandedService
      .fetchBranding()
      .pipe(
        takeUntil(this.destroy),
        catchError(_ => of(null))
      )
      .subscribe(_ => (this.isLoaded = true));
  }

  findCompany() {
    if (this.findCompanyForm.invalid || this.isInProgress) {
      return;
    }

    this.isInProgress = true;

    const email = this.emailControl.value;

    // This component is present only in web version
    // and has no need to handle inline Recaptcha.
    this.recaptchaService
      .execute(this.recaptcha)
      .pipe(
        switchMap((token: string) => {
          const dismissedCaptcha = token === null;

          if (dismissedCaptcha) {
            return throwError(null);
          }

          return this.userResource.findCompany(token, email);
        }),
        takeUntil(this.destroy)
      )
      .subscribe(
        () => {
          this.isInProgress = false;
          this.stateService.go('find-company-email-sent', { email });
        },
        () => {
          this.isInProgress = false;
        }
      );
  }
}
